import React from 'react';
import PropTypes from 'prop-types';
import assign from 'lodash/assign';

import Input from 'zignal-landscape/lib/Input';
import Label from 'zignal-landscape/lib/Label';
import Remove1Icon from 'zignal-landscape/lib/Icon/Remove1Icon';
import Save1Icon from 'zignal-landscape/lib/Icon/Save1Icon';

import styles from './WorkbenchValueEditInput.css';


class WorkbenchValueEditInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeNewFieldValueName = this.onChangeNewFieldValueName.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    const valueName = this.props.value ? this.props.value.name : null;
    this.state = {
      editingFieldValueName: valueName
    };
  }

  onChangeNewFieldValueName(e){
    this.setState({editingFieldValueName: e.target.value});
  }

  handleUpdate(){
    const {onUpdate, field, onCancel} = this.props;
    const value = this.props.value ? this.props.value : {};
    const {editingFieldValueName} = this.state;
    const updatedFieldValue = assign({}, value, {name: editingFieldValueName});
    onUpdate(field._id, updatedFieldValue);
    onCancel();
  }

  handleCancel(){
    const { onCancel } = this.props;
    onCancel();
  }

  render() {
    const {editingFieldValueName} = this.state;

    return (<span>
      <div className={styles.fieldValueLabel}>
        <Label>Value Name</Label>
      </div>
      <form
        className={styles.form}
        onSubmit={(e) => {e.stopPropagation(); e.preventDefault(); this.handleUpdate();}}
      >
        <div className={styles.fieldValueInput}>
          <Input
            autoFocus
            placeholder="Value Name"
            onChange={this.onChangeNewFieldValueName}
            value={editingFieldValueName || ''}
          />
        </div>
        <span
          className={styles.closeAction}
          onClick={this.handleCancel}
        >
          <Remove1Icon />
        </span>
        <span
          className={editingFieldValueName ? styles.checkActionValid : styles.checkAction}
          onClick={this.handleUpdate}
        >
          <Save1Icon />
        </span>
      </form>
    </span>);
  }
}

WorkbenchValueEditInput.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.object,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func
};

export default WorkbenchValueEditInput;
